module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ApplyInvoice"
  }, [_c('meta', {
    attrs: {
      "name": "description",
      "content": "以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    }
  }), _vm._v(" "), _c('title', [_vm._v("发票申请-以诺教育")]), _vm._v(" "), _c('headTop'), _vm._v(" "), _c('Breadcrumb', {
    staticClass: "zhCrumbs",
    attrs: {
      "separator": "<span class='demo-breadcrumb-separator'>></span>"
    }
  }, [_c('BreadcrumbItem', {
    attrs: {
      "href": "/orderList"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('BreadcrumbItem', {
    attrs: {
      "href": "/orderList"
    }
  }, [_vm._v("订单中心")]), _vm._v(" "), _c('BreadcrumbItem', {
    staticStyle: {
      "color": "#909090",
      "font-weight": "normal"
    }
  }, [_vm._v("申请发票")])], 1), _vm._v(" "), _c('div', {
    staticClass: "zhModule1"
  }, [_c('div', {
    staticClass: "zhInformation"
  }, [_c('p', {
    staticClass: "zhCode"
  }, [_vm._v("订单编号："), _c('span', [_vm._v(_vm._s(_vm.zhCode))])]), _vm._v(" "), _c('p', {
    staticClass: "zhCode"
  }, [_vm._v("实付金额：¥" + _vm._s(_vm.zhPir) + " "), _c('i', [_vm._v("发票金额不包含奖学金等优惠部分")])])]), _vm._v(" "), _c('div', {
    staticClass: "zhConfirm"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "zhInvoiceType"
  }, [_c('span', {
    staticClass: "zhType"
  }, [_vm._v("发票类型")]), _vm._v(" "), _c('span', {
    staticClass: "zhBottom zhAction"
  }, [(_vm.zhhide) ? _c('span', {
    staticClass: "zhYuan"
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "zhWorder"
  }, [_vm._v("增值税普通发票")]), _vm._v(" "), _c('span', {
    staticClass: "zhBottom zhBottom1"
  }, [(!_vm.zhhide) ? _c('span', {
    staticClass: "zhYuan"
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "zhWorder"
  }, [_vm._v("增值税专用发票")])]), _vm._v(" "), (_vm.zhhide) ? _c('div', {
    staticClass: "zhContent"
  }, [_c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent",
    attrs: {
      "type": "text",
      "placeholder": "发票抬头"
    },
    domProps: {
      "value": _vm.zhList.title
    }
  }), _c('i', {
    staticClass: "zherror"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhContentss"
  }, [_c('span', {
    staticClass: "zhType"
  }, [_vm._v("税号")]), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent1",
    attrs: {
      "type": "text",
      "placeholder": "纳税人识别号"
    },
    domProps: {
      "value": _vm.zhList.code
    }
  }), _c('i', {
    staticClass: "zherror"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.zhhide) ? _c('div', {
    staticClass: "zhContent"
  }, [_c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent",
    attrs: {
      "type": "text",
      "placeholder": "发票抬头"
    },
    domProps: {
      "value": _vm.zhList.title
    }
  }), _c('i', {
    staticClass: "zherror"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent",
    attrs: {
      "type": "text",
      "placeholder": "纳税人识别号"
    },
    domProps: {
      "value": _vm.zhList.code
    }
  }), _c('i', {
    staticClass: "zherror"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent",
    attrs: {
      "type": "text",
      "placeholder": "开户银行名称"
    },
    domProps: {
      "value": _vm.zhList.bank_name
    }
  }), _c('i', {
    staticClass: "zherror"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent",
    attrs: {
      "type": "text",
      "placeholder": "单位银行账号"
    },
    domProps: {
      "value": _vm.zhList.bank_code
    }
  }), _c('i', {
    staticClass: "zherror"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent",
    attrs: {
      "type": "text",
      "placeholder": "单位税务备案地址"
    },
    domProps: {
      "value": _vm.zhList.address
    }
  }), _c('i', {
    staticClass: "zherror"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent zphone1",
    attrs: {
      "type": "text",
      "placeholder": "单位电话号码"
    },
    domProps: {
      "value": _vm.zhList.mobile
    }
  }), _c('i', {
    staticClass: "zherror"
  })])]) : _vm._e(), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "zhAddressee"
  }, [_c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent",
    attrs: {
      "type": "text",
      "placeholder": "收件人姓名"
    },
    domProps: {
      "value": _vm.zhList.recipients_name
    }
  }), _c('i', {
    staticClass: "zherror"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "zhCascader"
  }, [_c('Cascader', {
    attrs: {
      "data": _vm.options,
      "render-format": _vm.format
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent",
    attrs: {
      "type": "text",
      "placeholder": "发票寄送地址"
    },
    domProps: {
      "value": _vm.zhList.mailing_address
    }
  }), _c('i', {
    staticClass: "zherror"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhContentss"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    staticClass: "zhInvoiceContent zphone",
    attrs: {
      "type": "text",
      "placeholder": "收件人手机号码"
    },
    domProps: {
      "value": _vm.zhList.recipients_mobile
    }
  }), _c('i', {
    staticClass: "zherror"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "zhSubmit"
  }, [_vm._v("申请发票")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zhTrue),
      expression: "zhTrue"
    }],
    staticClass: "zhTan"
  }, [_c('div', {
    staticClass: "zhBlock"
  }, [_c('div', {
    staticClass: "zhBlockTop"
  }, [_vm._v("提示"), _c('Icon', {
    staticClass: "zhIcon",
    attrs: {
      "type": "close"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "zhTishi"
  }, [_vm._v("发票信息提交成功，我们将尽快完成开票并邮寄")]), _vm._v(" "), _c('div', {
    staticClass: "zhQue"
  }, [_c('div', {
    staticClass: "zhDetermine"
  }, [_c('router-link', {
    staticClass: "zhQueDing",
    attrs: {
      "to": "/orderList"
    }
  }, [_vm._v("确定")])], 1)])])]), _vm._v(" "), _c('Bottom')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhInvoice"
  }, [_vm._v("确认发票信息 "), _c('span', [_vm._v("个人发票不需要填写“纳税人识别号”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 发票抬头")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 发票抬头")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 税号")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 开户行")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 账号")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 地址")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 电话")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhInvoice"
  }, [_vm._v("收件人信息 "), _c('span', [_vm._v("我们会尽快将发票寄送至收件地址，请完整填写")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 收件人")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 所在地区")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 详细地址")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zhType"
  }, [_c('i', [_vm._v("*")]), _vm._v(" 手机")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3155ca0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApplyInvoice/ApplyInvoice.vue
// module id = 549
// module chunks = 1